import { Button } from "@/components/ui/button";
import { AlertTriangle, Trash2 } from "lucide-react";
import { fmtDate, pendingDiscrepancyCount } from "./utils";

/** Top section: code, surgery name, patient + status badge + delete button. */
export default function CaseHeader({ cs, analyses, isAdmin, onDelete }) {
  const pending = pendingDiscrepancyCount(analyses);
  return (
    <div className="flex items-start justify-between flex-wrap gap-3">
      <div className="min-w-0">
        <div className="font-mono text-xs text-slate-500">{cs.case_code}</div>
        <h1 className="font-display text-2xl font-bold text-slate-900">
          {(cs.procedures && cs.procedures.length)
            ? cs.procedures.map((p) => p.name).join(" + ")
            : (cs.procedure_name || "Caso")}
        </h1>
        <div className="text-sm text-slate-600">
          {fmtDate(cs.surgery_date)} {cs.surgery_time && `· ${cs.surgery_time}`} · Paciente: <span className="font-medium">{cs.patient?.full_name}</span>
        </div>
        {(cs.unrecognized_procedures || []).length > 0 && (
          <div className="mt-2 inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-md bg-amber-50 text-amber-800 border border-amber-200" data-testid="unrecognized-alert">
            ⚠ Procedimento não cadastrado: <strong>{cs.unrecognized_procedures.join(", ")}</strong>
          </div>
        )}
        {pending > 0 && (
          <div className="mt-2 inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-md bg-amber-50 text-amber-800 border border-amber-200" data-testid="discrepancy-banner">
            <AlertTriangle className="h-3.5 w-3.5" />
            {pending} divergência(s) pendente(s) — veja na aba <strong>Divergências</strong> e confirme.
          </div>
        )}
      </div>
      <div className="flex items-center gap-2">
        {cs.pro_bono && (
          <div className="px-3 py-1.5 rounded-full text-xs font-bold bg-emerald-100 text-emerald-800 border border-emerald-300 uppercase tracking-wider flex items-center gap-1" data-testid="pro-bono-badge" title="Cirurgia pro bono — conta na produção mas NÃO gera faturamento.">
            ❤️ Pro Bono
          </div>
        )}
        <div className="px-3 py-1.5 rounded-full text-xs font-semibold bg-blue-50 text-blue-800 border border-blue-200 uppercase tracking-wider">
          {cs.status?.replace(/_/g, " ")}
        </div>
        {isAdmin && (
          <Button
            variant="ghost"
            size="sm"
            className="text-red-600 hover:bg-red-50 hover:text-red-700 border border-red-200"
            onClick={onDelete}
            data-testid="btn-delete-case"
            title="Excluir caso (admin)"
          >
            <Trash2 className="h-4 w-4 mr-1" /> Excluir caso
          </Button>
        )}
      </div>
    </div>
  );
}
